<template lang="pug">
  .member-settings-form-wrapper
    BNotification.test(:active.sync="error" type="is-danger" :duration="3000")
      | {{ errorMessage }}
    WtTitle(
      v-if="title"
      card-title semibold
    ) {{ title }}
    slot
    MemberSettingsFormControls(
      @disable-save="$emit('update:disable-save', true)"
      :disable-save="disableSave"
      :form-data="formData"
      @reset="$emit('reset')",
      :keys-to-reset="keysToReset"
      @form-error="handleFormError($event)"
    )
</template>

<script>
import WtTitle from "@@/WtTitle/WtTitle";
import MemberSettingsFormControls from "@@/MemberSettings/MemberSettingsFormControls";

export default {
  name: "MemberSettingsFormWrapper",

  components: { MemberSettingsFormControls, WtTitle },

  props: {
    formData: {
      type: Object,
      required: true
    },

    disableSave: {
      type: Boolean,
      default: true
    },

    keysToReset: {
      type: Array,
      default: () => []
    },

    title: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      error: false,
      errorMessage: null
    };
  },

  methods: {
    handleFormError(message) {
      this.errorMessage = message;
      this.error = true;
    }
  }
};
</script>

<style lang="sass" scoped></style>
